window.addEventListener("onEmbeddedMessagingReady", (event) => {
  console.log("Received the onEmbeddedMessagingConversationStarted event…");
  console.log("Event detail: ", event.detail);
  fixEmbeddedMessagingPosition();
  /* 防止 Salesforce 后续重写 */
  const embeddedMsgObserver = new MutationObserver(fixEmbeddedMessagingPosition);
  embeddedMsgObserver.observe(document.body, { childList: true, subtree: true });

  embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
    Country: {
      value: "United Kingdom",
    },
    Language: {
      value: "English",
      isEditableByEndUser: true,
    },
  });
});
window.addEventListener("onEmbeddedMessagingWindowClosed", (event) => {
  sendMessage();
});
/**
 * 关窗后 Salesforce 会废弃 sidebar 内的 wrapper（掏空），并在 body 下重建一个（fixed 定位，闪现在左上角）。
 * 修复只挪 DOM 位置、不动 Salesforce 的节点内容：新 wrapper 原样移进 sidebar（保持 Salesforce
 * 内部引用和事件监听有效），仅清理已被废弃的空壳。
 */
function fixChatButtonInSidebar() {
  const sidebar = document.querySelector('.ro-floating-sidebar');
  const orphan = [...document.querySelectorAll('.embeddedMessagingConversationButtonWrapper')].find(
    (el) => !el.closest('.ro-floating-sidebar') && el.querySelector('.embeddedMessagingConversationButton')
  );
  if (!sidebar || !orphan) return;

  sidebar.querySelectorAll('.embeddedMessagingConversationButtonWrapper').forEach((el) => {
    if (!el.querySelector('.embeddedMessagingConversationButton')) el.remove();
  });
  sidebar.insertBefore(orphan, sidebar.querySelector('.as-btt-btn'));
}
function sendMessage() {
  embeddedservice_bootstrap.utilAPI.sendTextMessage("Customer already left");
}
function initEmbeddedMessaging() {
  try {
    embeddedservice_bootstrap.settings.language = "en_US"; // For example, enter 'en' or 'en-US'

    embeddedservice_bootstrap.init(
      "00D7Q0000090wbR",
      "ENMessaging",
      "https://roborockeu2.my.site.com/ESWENMessaging1789111542924",
      {
        scrt2URL: "https://roborockeu2.my.salesforce-scrt.com",
      }
    );
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
}
function fixEmbeddedMessagingPosition() {
  const iframe = document.querySelector("iframe.embeddedMessagingFrame");

  if (iframe) {
    iframe.style.setProperty("z-index", "2147483647", "important");
  }
}

function addChatExpertMessage() {
  const embeddedMessagingIconChat = document.querySelector(
    ".embeddedMessagingIconChat"
  );

  if (
    embeddedMessagingIconChat &&
    !embeddedMessagingIconChat.nextElementSibling?.classList.contains("message")
  ) {
    const messageSpan = document.createElement("p");
    messageSpan.className = "message";
    messageSpan.textContent = "Chat with an expert";
    embeddedMessagingIconChat.insertAdjacentElement("afterend", messageSpan);
  }
}

// 观察DOM变化，当聊天图标加载后添加文本；Salesforce 任意时机重建按钮时立即收编回 sidebar
const embeddedMsgObserver = new MutationObserver((mutations) => {
  addChatExpertMessage();
  fixChatButtonInSidebar();
});

// 开始观察
if (document.body) {
  embeddedMsgObserver.observe(document.body, { childList: true, subtree: true });
}

// 也尝试在页面加载后延迟执行
setTimeout(addChatExpertMessage, 1000);
setTimeout(addChatExpertMessage, 2000);
